import { useEffect, useState } from 'react';
import { useIsClientSide } from './useIsClientSide';
export const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const isClient = useIsClientSide();

  useEffect(() => {
    if (!isClient) return;
    const header = document.getElementById('header-elty');
    setHeaderHeight(header?.clientHeight || 0);
  }, [isClient]);
  return headerHeight;
};
